/* 見出し */
import React, { memo } from 'react';
var Label = function (_a) {
    var title = _a.title;
    return (React.createElement("div", { className: "my-3" },
        React.createElement("div", { className: "col-md-12 col-sm-12" },
            React.createElement("div", { className: "my-2" },
                React.createElement("div", { className: "nav nav-tabs" }, title)))));
};
export default memo(Label);
